import script from "./CustomerButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerButton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerButton.vue?vue&type=style&index=0&id=236b1ebe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236b1ebe"]])

export default __exports__